module.exports = __webpack_public_path__ + "img/20190621161925059.1e58a27c.png";